import { type FC, type ReactNode } from 'react';
import styles from './DotsWrapper.scss';

const DotsWrapper: FC<{ children: ReactNode }> = ({ children }) => {
    return <div className={styles.dotsWrapper}>{children}</div>;
};

export default DotsWrapper;
